export default "__VITE_ASSET__C1lCrP1I__"